import { useRef } from "react";
import { isNative, takePhoto } from "../native";

function UploadZone({value,onChange,t}){
  const ref=useRef();
  const handleNativeCamera=async()=>{
    const dataUrl=await takePhoto();
    if(dataUrl){
      const res=await fetch(dataUrl);const blob=await res.blob();
      const file=new File([blob],"photo_"+Date.now()+".jpg",{type:"image/jpeg"});
      onChange(file);
    }
  };
  return(
    <div className={`upz ${value?"filled":""}`} onClick={()=>{if(isNative()){handleNativeCamera();}else{ref.current.click();}}}>
      <input ref={ref} type="file" accept="image/*,.pdf" style={{display:"none"}} onChange={e=>{const f=e.target.files[0];if(f)onChange(f);}}/>
      {value?<div style={{fontSize:13,color:"var(--grn)",fontWeight:500}}>{value.name} ({(value.size/1024).toFixed(0)} KB)</div>
            :<div style={{fontSize:13,color:"var(--g400)"}}>{isNative()?"📷 Capture or Choose File":t.attachFile}</div>}
    </div>
  );
}
export default UploadZone;
